<script setup lang="ts">
    import type { LinkWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Text Widget
     * renders normal text or as a hint
     */
    defineProps<IWidgetProps<LinkWidgetData>>();
</script>
<template>
    <atm-link
        :link="data.value"
        styling="solid-secondary"
        class="cms-link-widget" />
</template>
